<template>
  <section class="share-audio vh100">
    <header>
      <img :src="info.avatar || avatarHolder" alt="avatar" @click.prevent/>
      <span> 我已在{{ `「${info.courseName || '微课'}」` }}学习 <em>{{ info.daysPassed || 0 }}</em> 天</span>
    </header>

    <div class="share-audio-main">
      <h1>{{ info.shareContent || '与微课一起成长' }}</h1>
      <hr/>
      <p class="share-audio-main-teacher">{{ info.teacher ? info.teacher.name || '老师' : '老师' }}这样说：</p>
      <share-audio-player :info="info" :fromShare="fromShare"/>
      <img class="share-audio-main-qrArea" v-if="!fromShare" src="../../assets/images/share_qr.png" alt="qr" @click.prevent/>
      <img class="share-audio-main-qrArea" v-else src="../../assets/images/share_qr_invi.png" alt="qr" @click.prevent/>
      <img class="share-audio-main-qrCode" :src="info.qrcode" alt="qrCode"/>
    </div>
  </section>
</template>

<script>
import avatarHolder from './.default/avatar.png'
import ShareAudioPlayer from './ShareAudioPlayer'

export default {
  props: ['info', 'fromShare'],

  components: {
    ShareAudioPlayer
  },

  data () {
    return {
      avatarHolder
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.share-audio {
  height: 100%;
  width: 100%;
  overflow: hidden;

  header {
    width: rem(665);
    margin: rem(90) auto rem(50) auto;
    color: #fff;

    img {
      height: rem(50);
      width: rem(50);
      margin-right: rem(13);
      border-radius: 50%;
      line-height: rem(50);
      vertical-align: middle;
    }

    span {
      display: inline-block;
      width: 90%;
      font-size: rem(28);
      line-height: rem(50);
      vertical-align: middle;
    }

    em {
      display: inline-block;
      font-size: rem(38);
      line-height: rem(50);
    }
  }

  &-main {
    position: relative;
    height: rem(860);
    width: rem(590);
    padding-left: rem(50);
    margin: 0 auto;
    box-shadow: 0 rem(15) rem(55) rgba(224,64,0,.48);
    background-color: #fff;
    border-radius: rem(16);
    overflow: hidden;

    h1 {
      width: rem(540);
      color: #000;
      font-size: rem(38);
      line-height: rem(60);
      margin-top: rem(60);
      margin-bottom: rem(40);
    }

    hr {
      border: none;
      height: rem(6);
      width: rem(60);
      background-color: #FF8900;
      margin-bottom: rem(87);
    }

    &-teacher {
      color: #999;
      font-size: rem(28);
      line-height: rem(30);
      margin-bottom: rem(30);
    }

    &-qrArea {
      position: absolute;
      bottom: 0;
      left: 0;
      height: rem(190);
      width: rem(640);
    }

    &-qrCode {
      position: absolute;
      bottom: rem(30);
      left: rem(112);
      height: rem(140);
      width: rem(140);
    }
  }
}
</style>
